var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C5.5 1 1 5.5 1 11C1 13.4286 1.92857 15.7143 3.35714 17.4286L1.71429 22.4286L6.92857 20.1429C8.14286 20.7143 9.57143 21 11 21C16.5 21 21 16.5 21 11C21 5.5 16.5 1 11 1Z",
    stroke: "#0B8901",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.6429C16.7143 14 16.7143 13.5 16.6429 13.3571C16.5714 13.2143 16.4286 13.2143 16.1429 13.0714C15.8571 12.9286 14.5714 12.2857 14.3571 12.2143C14.1429 12.1429 13.8571 12.1429 13.7143 12.4286C13.4286 12.7857 13.2143 13.1429 13 13.3571C12.8571 13.5 12.5714 13.5714 12.3571 13.4286C12.0714 13.2857 11.2143 13 10.2143 12.1429C9.42857 11.4286 8.92857 10.5714 8.71429 10.2857C8.57143 10 8.71429 9.85714 8.85714 9.71429C9 9.57143 9.14286 9.42857 9.28571 9.28571C9.42857 9.14286 9.5 9.07143 9.57143 8.85714C9.64286 8.71429 9.57143 8.5 9.5 8.35714C9.42857 8.21429 8.92857 6.92857 8.71429 6.42857C8.57143 6 8.42857 6 8.14286 6C8.07143 6 7.92857 6 7.85714 6C7.5 6 7.14286 6.07143 6.92857 6.35714C6.64286 6.64286 6 7.28571 6 8.57143C6 9.85714 6.92857 11.1429 7.07143 11.2857C7.21429 11.4286 8.92857 14.1429 11.5714 15.2857C13.6429 16.1429 14.2857 16.0714 14.7143 16C15.4286 15.7857 16.2857 15.2857 16.5 14.6429Z",
    stroke: "#0B8901"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.c59af5f8440cc8eda94313df0de2bfa3.svg";
export { ForwardRef as ReactComponent };